import React, { createContext, useState } from "react";



export const PaginationContext = createContext({})

const PaginationProvider  = ({children}) => {
    const [pagination , setPagination] = useState({
        'currentPage': 1,
        'totalView': 10,
    })
    return(
        <PaginationContext.Provider value={{  pagination , setPagination}}>
            {children}
        </PaginationContext.Provider>
    )

}

export default PaginationProvider